'use strict';

import Vue from 'vue/dist/vue.common.js';
import VueResource from 'vue-resource';
import Cookies from '../../modules/cookies';

Vue.use(VueResource);

const passcodeUri = '/login/code';
const SessionForm = Vue.extend({
  data() {
    return {
      feedback: null,
      email: null,
      requesting_passcode: false,
      passcode_sent: false
    };
  },
  mounted () {
    this.feedback = this.$el.getAttribute('data-init-feedback');
    Vue.http.interceptors.push( (request, next) => {
      const csrf_token = Cookies.get('csrf_token');
      request.headers.set('X-CSRF-TOKEN', csrf_token);
      next();
    });
  },
  methods: {
    requestPasscode() {
      const self = this;
      let userData;
      self.requesting_passcode = true;
      userData = {
        user: {
          email: self.email
        }
      };
      self.$http.post(passcodeUri, userData).then(
        // Success
        response => {
          self.feedback = response.data.message;
          self.requesting_passcode = false;
          self.passcode_sent = true;
        },
        // Failure
        response => {
          setTimeout(function() {
            self.requesting_passcode = false;
            self.feedback = response.data.error;
          }, 1000);
        }
      );
    },
    submitHandler(event) {
      const self = this;
      if (!self.passcode_sent) {
        event.preventDefault();
      }
    }
  }
});

export default SessionForm;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/session-form.js